import Vue from 'vue'

export const getAdverts = () => Vue.axios.get('jobcards')
export const getUnModeratedAdverts = params => Vue.axios.get('jobCards/unModerated', { params })
export const ongoingBidsSearch = () => Vue.axios.post('jobcards/ongoing-bids-search')

export const getAdvert = id => Vue.axios.get(`jobcards/${id}`)
export const createAdvert = data => Vue.axios.post('jobcards', data)
export const updateAdvert = (id, data) => Vue.axios.put(`jobcards/${id}`, data)
export const deleteAdvert = id => Vue.axios.delete(`jobcards/${id}`)
export const moderateAdvert = id => Vue.axios.put(`jobcards/${id}/moderated`)
export const makeOffer = (id, offer) => Vue.axios.post(`jobcards/${id}/offers`, offer)
export const updateMinNettoWanted = (id, minNettoWanted) => Vue.axios.put(`jobcards/${id}/amount`, minNettoWanted)
export const deleteNewOfferFlag = id => Vue.axios.delete(`jobcards/${id}/newOfferFlag`)

export const uploadCv = (id, cv) => Vue.axios.put(`jobcards/${id}/cv`, cv)
export const deleteCv = id => Vue.axios.delete(`jobcards/${id}/cv`)
export const uploadPicture = (id, picture) => Vue.axios.put(`jobcards/${id}/picture`, picture)
export const deletePicture = id => Vue.axios.delete(`jobcards/${id}/picture`)

export const searchAdverts = data => Vue.axios.post('jobcards/search', data)
export const searchAdWatchAdverts = data => Vue.axios.post('jobcards/adwatch-based-search', data)
export const markAsRead = id => Vue.axios.put(`jobcards/${id}/markAsRead`)
export const markAsHidden = id => Vue.axios.put(`jobcards/${id}/markAsHidden`)



// WEBPACK FOOTER //
// ./src/services/adverts.js